import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { INPUT_MASKS, INPUT_VARIANTS } from "./constants";

export const inputDataSchema = z.object({
  type: z.string().optional(),
  name: z.string().optional(),
  value: z.string().optional(),
  variant: z.enum(INPUT_VARIANTS).optional(),
  mask: z.enum(INPUT_MASKS).optional(),
  size: z.enum(SIZES).optional(),
  placeholder: z.string().optional(),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  required: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
});

export type InputDataProps = z.infer<typeof inputDataSchema>;
